//Package import 
import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";

//functional Import 
import Switch from "@mui/material/Switch";
import CustomModal from "../../../utils/resuableComponents/CustomModal";
import DetailedViewSellShares from "../../../utils/resuableComponents/DetailedViewSellShare";
import DetailedViewBuyShares from "../../../utils/resuableComponents/DetailedViewBuyShares";
import { showToast } from "../../../utils/constants/Toaster";
import { userDetailsApi, approveSellShare,editShareApproved } from "../../../services/apiServices/PostServices";
import { ShareValueDetials } from "../../../services/apiServices/GetServices";
import Loader from "../../loadingScreens/Loader";
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button';
import { disableUser } from "../../../services/apiServices/PostServices";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { DisableUserModalText, EnableUserModalText,ErrorMessageShareQunatiy,ErrorMessageshareAmount,ErrorTextMessage } from "../../../utils/TextInputUtils";
import EditUserDetails from "./EditUserDetails";


const UserDetailedView = (props) => {
    const history = useHistory();
    const [show, setShow] = useState(false);
    const [isLoader, setIsLoader] = useState(false)
    const [file, setFile] = useState("")
    const [simpleModal, setSimpleModal] = useState(false);
    const [shareEditConfirm,setShareEditConfirm]=useState(false)
    const handleClose = () => setShow(false);
    const closeSimpleModal = () => setSimpleModal(false)
    const closeShareEdit = () => setShareEditConfirm(false)
    const [userDetails, setUserDetails] = useState()
    const [sellSharesViewModal, setSellShareViewModal] = useState(false)
    const [buySharesViewModal, setBuySharesViewModal] = useState(false)
    const [buyShareData, setBuyShareData] = useState([])
    const [sellShareData, setSellShareData] = useState([])
    const [requestData, setRequestData] = useState([])
    const [historyData, setHistoryData] = useState([])
    const [shareValueDetails, setShareValueDetails] = useState([])
    const [shareData, setShareData] = useState([])
    const [buyData, setBuyData] = useState([])
    const disableStatus = props?.location?.state?.info?.is_active;
    const [Checked, setChecked] = useState(disableStatus);
    const [totalShares, setTotalShares] = useState("")
    const [totalInvestedAmount, setTotalInvestedAmount] = useState(0)
    const [range1maxValue, setRange1MaxValue] = useState("")
    const [range1Val, setRange1Val] = useState(0)
    const [range2Val, setRange2Val] = useState(0)
    const [editModalOpen, setEditModalOpen] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [editShareModal, setEditShareModal] = useState(false)
    const [shareQuantity, setShareQuantity] = useState("")
    const [shareAmount, setShareAmount] = useState("")
    const [isBuy,setIsBuy]=useState(true)
    const [shareId,setShareId]=useState("")
    const [shareName,setShareName]=useState('')
    const [shareValue,setShareValue]=useState('')
    const [message,setMessage]=useState("")
    const userId = props?.location?.state?.info?.id

    useEffect(() => {
        if (userId !== "") {
            handleUSerDetailsApi()
        }
    }, []);    
    
    useEffect(() => {
        shareValueDetailsApi()
    }, []);

    const buttonStyle = {
        backgroundColor: "#0A2FB6", // Set your desired background color
        color: 'white', // Set the text color if needed
    };
    //function call to close sell share approval modal
    const closeSellShareView = () => {
        setSellShareViewModal(false)
        handleUSerDetailsApi()
    }

    //function call to close modal
    const handleModalClose = () => {
        setEditModalOpen(false)
        handleUSerDetailsApi()
    }
    
    //function call  to open modal
    const handleModalOpen = () => {

        setEditModalOpen(true)
    }

    //function call to close edit share modal
    const handleShareEditClose = () => {
        setEditShareModal(false)
    }
    //function call to open edit share modal
    const handleOpenEditShare = (item) => {
       
        setShareName(item?.share_name)
        setShareValue(item?.share_value)
        setShareId(item?.id)
        if(item?.buy_amount === 0){
            setIsBuy(false)
            setShareQuantity(item?.sell_shares)
            setShareAmount(item?.sell_amount)
        }else{
            setIsBuy(true)
            setShareQuantity(item?.buy_shares)
            setShareAmount(item?.buy_amount)
        }
        setEditShareModal(true)
    }

    //function call to close buy share approval modal
    const closeBuyShareView = () => {
        setBuySharesViewModal(false)
        handleUSerDetailsApi()
    }

    //function to open simple modal
    const handleSimpleModal = (e) => {
        setSimpleModal(true);
        if (e.target.checked) {
            setChecked(1)
        } else {
            setChecked(0)
        }
    }
    //function to open sellShareModal
    const handleSellShareAction = (data) => {
        setSellShareViewModal(true)
        setShareData(data)
    }

    //function for the handle buyshare actions
    const handleBuyShareAction = (data) => {
        setBuySharesViewModal(true)
        setBuyData(data)
    }

    const normalTime = new Date(userDetails?.created)
    const loginTime = userDetails?.loginTime === null ? new Date() : new Date(userDetails?.loginTime)

    const createdTime = normalTime.toLocaleString();
    const convertedLoginTime = loginTime.toLocaleString();

    const userdetailsData1 = [
        { title: 'Name :', description: `${userDetails?.first_name}  ${userDetails?.last_name} ` },
        { title: 'PhoneNumber :', description: `${userDetails?.phone_number}` },
        { title: 'Email :', description: `${userDetails?.email}` },
        { title: 'Address :', description: `${userDetails?.address1 !== "" ? userDetails?.address1 : "-"}` },
        { title: 'City :', description: `${userDetails?.city_name}` },
        { title: 'Post Code :', description: `${userDetails?.post_code}` },
        { title: 'Account Created Date :', description: `${createdTime}` },
        { title: 'Last Login :', description: `${convertedLoginTime}` },

    ]
    const userdetailsData2 = [
        { title: 'Name as per Bank Records :', description: `${userDetails?.name_on_bank !== 'null' && userDetails?.name_on_bank  !== null ? userDetails?.name_on_bank : "-"}` },
        { title: 'Bank Name :', description: `${userDetails?.bank_name !== "" && userDetails?.bank_name !== 'null' && userDetails?.bank_name !== null   ? userDetails?.bank_name : "-"}` },
        { title: 'Bank Account Number :', description: `${userDetails?.bank_account_no !== 'null' && userDetails?.bank_account_no !== null ? userDetails?.bank_account_no : "-"}` },
        { title: 'IFSC Code :', description: `${userDetails?.bank_ifsc !== 'null' && userDetails?.bank_ifsc !== null ? userDetails?.bank_ifsc : "-"}` },
        { title: 'Demat Account :', description: `${userDetails?.demat_account !== "" ? userDetails?.demat_account : "-"}` },
        { title: 'Unique Code :', description: `${userDetails?.voucher !== null ? userDetails?.voucher : "-"}` },

    ]
   
    const popUpMessage = Checked === 0 ? `${userDetails?.first_name} has ${userDetails?.current_share === null ? 0 : userDetails?.current_share} ${DisableUserModalText}` : `${EnableUserModalText}`

    //function call to call user details apis
    const handleUSerDetailsApi = async () => {

        const reqbody = {
            id: userId
        }

        try {
            const res = await userDetailsApi(`userDetails`, reqbody);
            if (res?.success) {
                setUserDetails(res?.data[0])
                setBuyShareData(res?.buy_shares)
                setSellShareData(res?.sell_shares)
                const combined = [
                    ...(res?.buy_shares || []),
                    ...(res?.sell_shares || [])
                ];
                setRequestData(combined.sort((a, b) => new Date(b.created) - new Date(a.created)))
                setHistoryData(res?.share_history)
            } else {
                // showToast(3, res?.message)
                console.log("res", res?.message)
            }

        } catch (error) {
            console.log(error);
        }
    }

    //function to call share value details
    const shareValueDetailsApi = async () => {
        const res = await ShareValueDetials("osanShares")
        if (res?.success) {
            setShareValueDetails(res?.osanShares)
            setRange1MaxValue(res?.osanShares[0]?.to_)
            setRange1Val(res?.osanShares[0]?.value)
            setRange2Val(res?.osanShares[1]?.value)
            setTotalShares(res?.total_shares)
            setTotalInvestedAmount(res?.total_amount)

        } else {
            console.log("res", res?.message)
        }
    }

    const addOrdinalSuffix = (day) => {
        if (day >= 11 && day <= 13) {
            return day + 'th';
        }

        switch (day % 10) {
            case 1:
                return day + 'st';
            case 2:
                return day + 'nd';
            case 3:
                return day + 'rd';
            default:
                return day + 'th';
        }
    }

    //function call to change date format 
    const handleFormatedDate = (date) => {
        const originalDate = new Date(date); // Replace this with your date object
        const options = {
            weekday: 'short',  // Short weekday name (e.g., Wed)
            day: 'numeric',    // Numeric day of the month (e.g., 1)
            month: 'short',    // Short month name (e.g., Jan)
        };
        const formattedDate = originalDate.toLocaleDateString('en-US', options);
        const dayWithOrdinal = addOrdinalSuffix(originalDate.getDate());
        const finalFormattedDate = formattedDate.replace(originalDate.getDate(), dayWithOrdinal);
        return finalFormattedDate
    }

    //function call to handle no of shares
    const handleNoOfshares = (share, value) => {
        const totalSharesAlreadyPurchased = parseInt(totalShares); // Total shares already purchased
        const newSharesToBePurchased = parseInt(share); // New shares to be purchased

        // Calculate total cost
        const totalCost = newSharesToBePurchased * value;
        return totalCost
    }

    //function call to handle share amount
    const handleShareAmount = (amount, value) => {

        const alreadyInvested = totalInvestedAmount === null ? 0 : parseInt(totalInvestedAmount)

        let totalAmountInvested = amount / value

        return totalAmountInvested
    }

    //function call to change time format 
    const formatTime = (inputTime) => {
        const options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        const formattedTime = new Date(inputTime).toLocaleString('en-US', options);

        const [datePart, timePart] = formattedTime.split(', ');
        const [month, day, year] = datePart.split('/');
        const [hour, minute] = timePart.split(':');
        // Convert 24-hour time to 12-hour time
        const period = +hour >= 12 ? 'pm' : 'am';
        const formattedHour = +hour % 12 || 12;
        return `${month}/${day}/${year} at ${formattedHour}:${minute}`;
    }

    //function call to hit disable api.
    const handledisable = async () => {
        const endpoint = `disable_user/${Checked}`
        const reqBody = {
            id: userId
        }
        const res = await disableUser(`${endpoint}`, reqBody);
        if (res?.success) {
            setSimpleModal(false)
            showToast(1, Checked === 0 ? "User disabled successfull" : "User enabled successfull")
            history.push("/admin/userManagement")
        } else {
            //  showToast(3, res?.message)
            console.log("res", res?.message)
        }
    }

    //function to call preview modal
    const handleShow = (value) => {
        setFile(value)
        setShow(true);
    }

    //function call to call edit share allocation api
    const callEditShareAllocationApi = async () => {
           const reqBody = {
               share_id:shareId,
               is_buy:isBuy,
               shares: parseInt(shareQuantity),
               amount: parseInt(shareAmount),
               message:message
        } 
          try {
            const res = await editShareApproved(`editShares`, reqBody);
            if(res?.success){
                setErrorMessage("")
                setMessage("")
                showToast(1,res?.message)
                setShareEditConfirm(false)
                setEditShareModal(false)
                handleUSerDetailsApi()
            }else{
                console.log("res",res?.message)
            }
          }catch(error){
            console.log("error",error)
          }
    }

    const handleEditShareUpdate =  async () => {
        
       
        if(shareQuantity === "" ){
            setErrorMessage(ErrorMessageShareQunatiy)
        }else if(shareAmount === "" ){
            setErrorMessage(ErrorMessageshareAmount)
        }
        else if(message === ""){
            setErrorMessage(ErrorTextMessage)
        }
        else if(shareQuantity !== "" && shareAmount !== "" && message !== ""){
            setShareEditConfirm(true)
        }
    } 

    //function call to handle edit share quantity
    const handleOnQuantity = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            // setInputValue(newInputValue);
            setShareQuantity("");
        } else {
            setShareQuantity(Value)
        }
    }
    //function call to handle edit share amount
    const handleOnShareAmount = (e) => {
        let Value = e.target.value;
        if (Value.length === 1 && Value[0] === ' ') {
            // setInputValue(newInputValue);
            setShareAmount("");
        } else {
            setShareAmount(Value)
        }
    }

    const handleMessage = (e) => {
        let messageValue  =e.target.value 
  
        if (messageValue.length === 1 && messageValue[0] === ' ') {
          // setInputValue(newInputValue);
          setMessage("");
        }else{
            setMessage(messageValue)
        }
    }

    return (
        <div className="">
            <div className="d-flex flex-row justify-content-between align-items-center w-100 border-bottom p-2">
                <h1 className="fs-4 ms-4 Montserrat fw-semi-bold">
                    Account Summary of {userDetails?.first_name} {userDetails?.middle_name} {userDetails?.last_name}
                </h1>
            </div>
            <div className="container   mt-2">
                <div className="col-10 d-flex flex-row text-center justify-content-around">
                    <div className="col-lg-3 mx-4 d-flex flex-column text-center boxBackgroundStyle border rounded p-2">
                        <h4 className="colorPrimary">Current Shares</h4>
                        <h4 className="colorPrimary">{userDetails?.current_share === null ? 0 : userDetails?.current_share} </h4>
                        <div className="align-self-end ">
                        </div>
                    </div>
                    <div className="col-lg-3 mx-4 d-flex flex-column text-center boxBackgroundStyle border rounded p-2">
                        <h4 className="colorPrimary">Investments</h4>
                        <h4 className="colorPrimary">₹{userDetails?.investment === null ? 0 : userDetails?.investment}</h4>
                        <div className="align-self-end p-1">
                        </div>
                    </div>
                    <div className="col-lg-3 mx-4 d-flex flex-column text-center boxBackgroundStyle border rounded p-2">
                        <h4 className="colorPrimary">Total Shares Purchased</h4>
                        <h4 className="colorPrimary">{userDetails?.total_shares_purchased !== null ? userDetails?.total_shares_purchased : 0}</h4>
                        <div className="align-self-end p-1">
                        </div>
                    </div>
                    <div className="col-lg-3 mx-4 d-flex flex-column text-center boxBackgroundStyle border rounded p-2">
                        <h4 className="colorPrimary">Total Shares Sold</h4>
                        <h4 className="colorPrimary">{userDetails?.total_shares_sold !== null ? userDetails?.total_shares_sold : 0}</h4>
                        <div className="align-self-end p-1">
                        </div>
                    </div>
                </div>
                {/* <hr className="m-0 my-3"></hr> */}
            </div>
            <div className="container-fluid ">
                <div className={sellShareData === null && buyShareData === null && historyData === null ? "col-lg-12 d-flex flex-row justify-content-center align-items-center" : "col-lg-12 d-flex flex-column "}>
                    <div className={sellShareData === null && buyShareData === null && historyData === null ? "d-flex col-lg-12 flex-column" : "col-lg-12 d-flex flex-column "}>

                        {/*-----------------------------------------------Approval request popup-------------------------------------------------  */}
                        {
                            sellShareData === null && buyShareData === null ? null :
                                <>
                                    {
                                        sellShareData !== null || buyShareData !== null ?
                                            <div className="my-3 m-0 text-center sharesBackground p-1 ">
                                                <h6 className="fs-5 m-0">User Shares Requests</h6>
                                            </div> :
                                            null
                                    }
                                    <div className="col-12 sub-height d-flex flex-row flex-wrap justify-content-around overflow-auto">
                                        {
                                            requestData?.map((data, index) => {
                                                return (
                                                    <div className="d-flex col-lg-5 flex-column border shadow border-1 mx-4 my-2 boxBackgroundStyle" key={index} >
                                                        <h5 className="sharesBackground p-2">{data?.buy_amount === 0 ? "Request of sell shares" : "Request of buy shares"}</h5>
                                                        <div className="d-flex flex-row justify-content-center align-items-center px-3">
                                                            <p className="text-start w-50 status-pending fw-bold fs-6">{data?.buy_amount === 0 ? "Requested Shares" : "Credited Amount"}</p>
                                                            <p className="text-start w-50 fw-bold fs-6">{data?.buy_amount === 0 ? `${data?.sell_shares} Shares` : `₹${data?.buy_amount}`}</p>
                                                        </div>
                                                        <div className="d-flex flex-row justify-content-center align-items-center px-3">
                                                            <p className="text-start w-50 status-pending fw-bold fs-6">Share Name</p>
                                                            <p className="text-start w-50 fw-bold fs-6">{data?.share_name}</p>
                                                        </div>
                                                        <div className="d-flex flex-row justify-content-center align-items-center px-3">
                                                            <p className="text-start w-50 status-pending fw-bold fs-6">Share value</p>
                                                            <p className="text-start w-50 fw-bold fs-6">{data?.share_value}</p>
                                                        </div>
                                                        <div className="d-flex flex-row justify-content-center align-items-center px-3">

                                                            <p className="text-start w-50 status-pending fw-bold fs-6">{data?.buy_amount === 0 ? "Approx. Share Amount" : "Approx. Share Quantities"} </p>
                                                            <p className="text-start w-50 fw-bold fs-6">{data?.buy_amount === 0 ? `₹ ${handleNoOfshares(data?.sell_shares, data?.share_value)}` : `${handleShareAmount(data?.buy_amount, data?.share_value)} Shares`}</p>
                                                        </div>
                                                        <div className="d-flex flex-row justify-content-center align-items-center px-3">
                                                            <p className="text-start w-50 status-pending fw-bold fs-6">Date And Time</p>
                                                            <p className="text-start w-50 fw-bold fs-6">{formatTime(data?.created)}</p>
                                                        </div>
                                                        <div className="my-1 align-self-center mb-2">
                                                            <button className="primaryButton px-3" onClick={() => data?.buy_amount === 0 ? handleSellShareAction(data) : handleBuyShareAction(data)}>
                                                                Take Action
                                                            </button>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </>
                        }
                        {/*------------------------------------------------ User details sectiom--------------------------------------------------- */}
                        {
                            userDetails !== undefined && editModalOpen ?
                                <EditUserDetails modalOpen={editModalOpen} modalClose={handleModalClose} userdetails={userDetails} /> :
                                null
                        }
                        <div className="my-3 m-0 text-center sharesBackground p-1 ">
                            <h6 className="fs-5 m-0">User Details</h6>
                        </div>
                        <div className="col-12 d-flex justify-content-end">
                            {/* <h6 onClick={() => handleModalOpen()} >Edit</h6> */}
                            <FontAwesomeIcon icon={faPenToSquare} style={{ color: "#0A2FB6", cursor: "pointer" }} onClick={() => handleModalOpen()} />
                        </div>
                        <div className="d-flex col-12 flex-row ">
                            <div className=" col-lg-6 px-5 border-end pt-2">
                                {userdetailsData1.map((item, index) => (
                                    <div className="d-flex flex-row justify-content-center align-items-start" key={index} >
                                        <p className="text-start w-50 status-pending fw-bold mb-2 pb-1">{item.title}</p>
                                        <div className="d-flex w-50 ms-5 m-0">
                                            <p className="text-start  fw-bold text-break mb-1 pb-1 ">{item.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className=" col-lg-6 px-5  pt-2">
                                {userdetailsData2.map((item, index) => (
                                    <div className="d-flex flex-row justify-content-center align-items-start" key={index} >
                                        <p className="text-start w-50 status-pending fw-bold mb-2 pb-1 ">{item.title}</p>
                                        <div className="d-flex w-50 ms-5">
                                            <p className="text-start  fw-bold text-break mb-1 pb-1 ">{item.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="d-flex flex-row justify-content-center align-items-center mt-1">
                            <p className="fw-semibold mb-0">Want to disable this customer?</p>
                            <Switch onClick={(e) => handleSimpleModal(e)} checked={disableStatus} />
                        </div>
                        {/* ------------------------------------------------------------------------------------------------------------ */}
                        <CustomModal
                            close={handleClose}
                            open={show}
                            imgvalue={file}
                        />
                        <CustomModal
                            close={closeSimpleModal}
                            open={simpleModal}
                            modalContent={popUpMessage}
                            Action={handledisable}
                        />
                         <CustomModal
                            close={closeShareEdit}
                            open={shareEditConfirm}
                            modalContent={"Are you sure want to edit the share allocation ?"}
                            Action={callEditShareAllocationApi}
                        />
                    </div>
                    {/*--------------------------------------------history data section-----------------------------------------------------------  */}
                    {
                        sellShareData === null && buyShareData === null && historyData === null ? null :
                            <div className={sellShareData === null && buyShareData === null && historyData === null ? "col-lg-12" : "col-lg-12"}>
                                <DetailedViewSellShares open={sellSharesViewModal} close={closeSellShareView} data={shareData} valueDetails={shareValueDetails} userId={userDetails?.id} currentShare={userDetails?.current_share} totalAmount={totalInvestedAmount} totalShares={totalShares} />
                                <DetailedViewBuyShares open={buySharesViewModal} close={closeBuyShareView} data={buyData} valueDetails={shareValueDetails} userId={userDetails?.id} totalAmount={totalInvestedAmount} totalShares={totalShares} />
                                <div className="sub-height ">
                                    <div className="my-3 m-0 text-center sharesBackground p-1">
                                        <h6 className="fs-5 mb-0">Transactions History</h6>
                                    </div>
                                    {historyData.map((item, index) => (
                                        <div className="d-flex  p-2 mx-2" key={index}>
                                            <div className=""style={{width:"99%"}} >
                                                <div className="d-flex flex-row justify-content-between">
                                                    <h6 className="colorPrimary w-25 m-0">{item?.buy_amount !== 0 ? "Form submission-purchase" : "Form submitted -sell "}</h6>
                                                    <div className="d-flex flex-column w-25">
                                                        <h6 className={item?.approved !== null ? "colorPrimary text-center ms-xxl-1 m-0" : "status-pending text-center m-0"}>{item?.approved !== null ? "Admin approved" : item?.approved === null && item?.cancel_reason !== null ? "" : "Pending for approval"}</h6>
                                                        {item?.approved !== null ? <p className="previewColor cursorPointer text-center ms-xxl-1  m-0" onClick={() => handleShow(item?.image_url)}>{"Preview Image"}</p> : ""}
                                                    </div>
                                                    <div className="w-25">
                                                        {
                                                            item?.approved === null && item?.cancel_reason !== null ?
                                                                <h6 className={"colorPrimary text-end"}>{"Shares Request Rejected"}</h6> :
                                                                <div className="d-flex flex-column">
                                                                    <h6 className={item?.approved !== null ? "colorPrimary  text-end m-0" : "status-pending text-end m-0"}> {item?.buy_amount !== 0 ? `${item?.share_name}  allocated` : `${item?.share_name} deducted`}</h6>
                                                                    {
                                                                        item?.approved !== null ?
                                                                            <div className="d-flex justify-content-end">
                                                                                <h6 className="fs-6 w-100 text-end m-0" style={item?.buy_amount !== 0 ? { color: '#0A6D26' } : { color: '#FF2C3C' }}> {item?.buy_amount !== 0 ? `+${item.buy_shares}` : `-${item.sell_shares}`} Shares</h6>
                                                                                {/* <h6 className="fs-6 m-0 ms-1" style={item?.buy_amount !== 0 ? { color: '#FF2C3C' } : { color: '#0A6D26' }}> {item?.buy_amount !== 0 ? `-${item.buy_amount}` : `+${item.sell_amount}`} Amount</h6> */}
                                                                            </div>
                                                                            : null
                                                                    }
                                                                </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div>
                                                </div>
                                                <div className="d-flex flex-row justify-content-between align-items-center align-content-center">
                                                    <div className="d-flex justify-content-center align-items-center">   <span className={item.created !== null ? "big-dot" : "dot"}></span></div>
                                                    <hr className="flex-fill track-line" />
                                                    {
                                                        item?.approved === null && item?.cancel_reason !== null ?
                                                            <div className="d-flex justify-content-center align-items-center"> <span className={"big-dot"}></span> </div> :
                                                            <div className="d-flex justify-content-center align-items-center" > <span className={item?.approved !== null ? "big-dot" : "dot"}></span>
                                                            </div>
                                                    }
                                                    {
                                                        item?.approved === null && item?.cancel_reason !== null ?
                                                            <hr className={"flex-fill track-line"} />
                                                            :
                                                            <hr className={item?.approved !== null ? "flex-fill track-line" : "flex-fill track-line-after"} />
                                                    }
                                                    {
                                                        item?.approved === null && item?.cancel_reason !== null ?
                                                            <div className="d-flex justify-content-center align-items-center" ><span className={"big-dot"}></span></div> :
                                                            <div className="d-flex justify-content-center align-items-center" > <span className={item?.approved !== null ? "big-dot" : "dot"}></span></div>
                                                    }
                                                </div>
                                                <div className="d-flex flex-row justify-content-between align-items-center">
                                                    <p className="w-25" >{handleFormatedDate(item.created)}</p>
                                                    <p className="w-25 " >{item.approved != null ? handleFormatedDate(item.approved) : null}</p>
                                                    <div className="d-flex flex-column">
                                                        {
                                                            item?.approved !== null ?
                                                                <h6 className="fs-6  text-end m-0 ms-1" style={item?.buy_amount !== 0 ? { color: '#FF2C3C' } : { color: '#0A6D26' }}> {item?.buy_amount !== 0 ? `-${item.buy_amount}` : `+${item.sell_amount}`} Amount</h6>
                                                                :
                                                                <h6 className="fs-6  text-end ">{""}</h6>
                                                        }
                                                        <p className="text-end">{item.approved != null ? handleFormatedDate(item.approved) : item?.approved === null && item?.cancel_reason !== null ? handleFormatedDate(item.modified) : null}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                        item?.approved !== null && item?.buy_amount !== 0 ?
                                                            <div className="d-flex justify-content-center align-items-center ms-3 mb-3" onClick={() => handleOpenEditShare(item)} >
                                                                <FontAwesomeIcon icon={faPenToSquare} style={{ color: "#0A2FB6", cursor: "pointer" }} />
                                                            </div> :
                                                            null
                                                    }
                                        </div>
                                    ))}
                                </div>
                            </div>
                    }
                </div>
            </div>
            {/* ---------------------------------edit share allocation modal------------------------------------------------ */}
            <Modal show={editShareModal} onHide={handleShareEditClose} centered size={"md"} backdrop="static" >
                <Modal.Header style={{ backgroundColor: "#0A2FB6", color: "white" }} data-bs-theme="dark" closeButton>
                    <h6 class="text-white fw-bold m-0 montserrat">{"Edit Share Allocation"}</h6>
                </Modal.Header>
                <Modal.Body class=" p-3   pt-0 pb-0">
                    {/* <h2 class="fs-5 text-center mx-2"> {"Edit Share Allocation"} </h2> */}
                    <h6 className="my-2" ><span className="fw-bold">Share Name :</span> {shareName}</h6>
                    <h6 className="my-2" > <span className="fw-bold ">Share Value :</span> {shareValue}</h6>
                    <div class="my-1" >
                        <h6 class="text-start m-0 mt-2 mb-2">Share Quantity</h6>
                        <input class="form-control form-control-lg" type="text" name="Share Quanity" placeholder="Please enter no of shares" value={shareQuantity} aria-label="default input example" onChange={(e) => { handleOnQuantity(e) }}></input>
                    </div>
                    <div class="" >
                        <h6 class="text-start m-0 mt-2 mb-2">Share Amount</h6>
                        <input class="form-control form-control-lg" type="text" name="Share Amount" placeholder="Please enter the share amount" value={shareAmount} aria-label="default input example" onChange={(e) => { handleOnShareAmount(e) }}></input>
                    </div>
                    <div class="mb-4" >
                    <h6 class="text-start m-0 mt-2 mb-2">Message</h6>
                   <textarea class="form-control form-control-lg" name="reason" id="exampleFormControlTextarea1" placeholder="Please enter the reason" rows="3" value={message}
                     onChange={(e) => { handleMessage(e)}}></textarea>
                    </div>
                    {errorMessage !== "" ? <h6 class="m-0 text-start text-danger">{errorMessage}</h6> : <h6 class="m-0 text-start text-danger" >{errorMessage}</h6>}
                </Modal.Body>
                <Modal.Footer class="d-flex justify-content-around ">
                    <div class="d-flex justify-content-around w-50 mb-1 mt-2">
                        <Button onClick={() => handleEditShareUpdate()} className="px-2 py-2 my-2" style={buttonStyle}>
                           Update
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
export default UserDetailedView